import { Body, SectionHeader } from "@sprout/typography.tsx";
import Preferences from "@components/preferences.tsx";
import { useTranslation } from "react-i18next";
import React, { createContext, useContext } from "react";
import useSubscriptions from "@/queries/use_subscriptions.ts";
import "@components/job_alerts/header.scss";

export const SubscriptionCountContext = createContext<number>(0);

export const SubscriptionCountProvider = ({ children }: { children: React.ReactNode }) => {
  const { data } = useSubscriptions();

  const count = data?.subscriptions?.length || 0;

  return <SubscriptionCountContext value={count}>{children}</SubscriptionCountContext>;
};

type JobAlertsHeaderProps = {
  jobAlertsPaused?: boolean;
  variant?: "page" | "tab";
};

export const JobAlertsHeader = ({ jobAlertsPaused, variant = "page" }: JobAlertsHeaderProps) => {
  const count = useContext(SubscriptionCountContext);

  const { t } = useTranslation("jobAlerts");

  const heading = () => {
    if (variant === "tab") return t("title");
    if (count > 0) return `${t("yourJobAlerts")} (${count})`;

    return t("yourJobAlerts");
  };

  return (
    <div className="job-alerts-page__header">
      <SectionHeader as="h2">{heading()}</SectionHeader>
      {jobAlertsPaused === false && (
        <div className="job-alerts-page__header__preferences">
          {variant === "page" && <Body>{t("preferences.emailFrequency")}</Body>}
          <Preferences label={variant === "tab" ? t("preferences.defaultEmailFrequency") : ""} />
        </div>
      )}
    </div>
  );
};
